$('#projectTexts').carousel('pause');


$('#solutionsCarousel').on('slide.bs.carousel', function (event) {
	$('#projectTexts').carousel(event.to);
	$('[data-target=\'#solutionsCarousel\']').removeClass('active')
		.eq(event.to).addClass('active')
});